import { AppPhase, DealingSubPhase, RouletteSubPhase } from '../models/communication/app-enums.model';
import { TableUpdate } from '../models/communication/app-state.model';

export abstract class GameFlowBase<Game> {
    protected readonly game!: Game;

    constructor(game: Game) {
        this.game = game;
    }

    /**
     * Called when the game is replaced (new round, game change) or its table goes away: stop anything the flow still runs.
     */
    destroy(): void {
        // Nothing runs by default
    }

    abstract update(tableUpdate?: TableUpdate, appPhase?: AppPhase, dealingSubPhase?: DealingSubPhase | RouletteSubPhase): void;
}
